module.exports = __webpack_public_path__ + "static/phone-5d4903ea2cb94ad2b72697b87227248a.svg";